angular.module('bmsApp.trugreen.schedule')
	.controller('TGMoveVisitModalCtrl', function ($scope,
												  $modalInstance,
												  $q,
												  $ngBootbox,
												  EmployeeSvc,
												  TGVisitSvc,
												  ConfigService,
												  TGScheduleSvc,
												  visitId,
												  moveDate) {


		function init() {
			$scope.config = ConfigService.config;
			$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
				options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
					parentEl: '.modal-content'
				})
			});

			TGVisitSvc.read(visitId)
				.then(function (response) {
					self.visit = response.data.tg_visit;
					self.loading = false;
					setupWatches();

					if (!self.visit.inactive) {
						self.technician = self.visit.employee;
						self.moveToDate = moveDate;
						self.visit.selected = (moveDate == null) ? false : true;
						angular.forEach(self.visit.treatments, (treatment) => {
							angular.extend(treatment, {
								'delete': false,
								inactive: !!treatment.inactive,
							});
						});
						visitSelectedChanged();
					}

				});
		}

		function setupWatches() {
			$scope.$watch('TGMoveVisitModalCtrl.visit', function (newVal, oldVal) {
				var treatmentsSelectedCount = 0;
				self.showMoveToDate = self.visit.selected;
				angular.forEach(self.visit.treatments, function(treatment) {
					if (treatment.selected) {
						treatmentsSelectedCount++;
						self.showMoveToDate = true;
					}

					// if (self.visit.selected) {
					// 	treatment.selected = true;
					// }
				});


				// if (!self.showMoveToDate) {
				// 	self.moveToDate = null;
				// 	self.employee = null;
				// }



			}, true);
		}

		function cancelVisit() {
			self.visit.inactive = true;
			self.visit.selected = false;
			self.visit.copy = false;
			self.visit.unconfirmed = false;
			angular.forEach(self.visit.treatments, function (treatment) {
				treatment.selected = false;
				if (!treatment.delete) {
					treatment.inactive = true;
				}

			});
		}

		function reinstateVisit() {
			self.visit.inactive = false;
			self.visit.copy = false;
			self.visit.unconfirmed = false;
		}

		function cancelTreatment(treatment) {
			angular.extend(treatment, {
				inactive: true,
				// deselect treatment so that it doesn't get moved
				selected: false,
			});
		}

		function removeTreatment(treatment) {
			angular.extend(treatment, {
				'delete': true,
				selected: false,
			});
		}

		function enableTreatment(treatment) {
			angular.extend(treatment, {
				delete: false,
				inactive: false
			});
		}

		function visitSelectedChanged() {
			angular.forEach(self.visit.treatments, function (treatment) {
				if (treatment.delete === false && treatment.inactive === false) {
					angular.extend(treatment, {
						selected: self.visit.selected,
					});
				}
			});
		}

		function dateChanged() {
			if (self.moveToDate != null) {
				var employeeParams = {
					filter: {
						availableOnDate: self.moveToDate,
						status: true
					}
				};

				EmployeeSvc.index(employeeParams)
					.then(function (response) {
						self.employees = response.data.employee_collection;
						if (self.employees.length === 1) {
							self.technician = self.employees[0];
						}
					});
			}
		}

		function cancel() {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		}

		function submit() {

			if (self.formValidator.valid()) {
				self.processing = true;
				var params = {
					visit: self.visit,
					moveToDate: self.moveToDate,
					technician: self.technician
				};
				TGScheduleSvc.moveVisit(params)
					.then(function (response) {
						$modalInstance.close(response);
					})
					.finally(function () {
						self.processing = false;
					});
			}
		}

		function rolloverToggled(){
			if(!self.visit.copy){
				self.visit.unconfirmed = false;
			}
		}


		var self = $scope.TGMoveVisitModalCtrl = {
			formvalidatorconfig: {},
			formValidator: {},
			loading: true,
			processing: false,
			moveToDate: null,
			visit: {},
			showMoveToDate: false,
			methods: {
				init: init,
				cancel: cancel,
				submit: submit,
				cancelVisit: cancelVisit,
				reinstateVisit: reinstateVisit,
				cancelTreatment: cancelTreatment,
				removeTreatment: removeTreatment,
				enableTreatment: enableTreatment,
				visitSelectedChanged: visitSelectedChanged,
				dateChanged: dateChanged,
				rolloverToggled :rolloverToggled,
			}
		};


	});
